import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

export class InputFloating extends PureComponent {
    state = {
        isFilled: false,
        isValid: true
    };

    handleChange = event => {
        this.setState({
            isFilled: !!event.currentTarget.value,
            isValid: event.currentTarget.checkValidity()
        });
    };

    render() {
        const {
            label,
            id,
            type,
            pattern,
            required = null,
            description,
            step,
            validationMessage,
            min,
            max
        } = this.props;

        return (
            <InputContainer>
                {description && <SupplementaryText>{description}</SupplementaryText>}
                <Wrapper>
                    <Input
                        id={id}
                        isFilled={this.state.isFilled}
                        isValid={this.state.isValid}
                        max={max}
                        min={min}
                        name={id}
                        onChange={this.handleChange}
                        pattern={pattern}
                        required={required}
                        step={step}
                        type={type}
                    />
                    <Label isFilled={this.state.isFilled} htmlFor={id}>
                        {label}
                    </Label>
                </Wrapper>
                <ValidationMessage isValid={this.state.isValid} isFilled={this.state.isFilled}>
                    {validationMessage}
                </ValidationMessage>
            </InputContainer>
        );
    }
}

const InputContainer = styled.div`
    margin-bottom: 1.5rem;
`;

const Wrapper = styled.div`
    margin-bottom: 2px;
    padding: 1.5rem 0 0;
    position: relative;
`;

export const Input = styled.input`
    background-color: #f8f8f8;
    border-radius: 0.2rem;
    border: 1px solid #e2e1de;
    font-family: inherit;
    font-size: 1.4rem;
    height: 3.5rem;
    padding: 0.5rem;
    width: 100%;

    ${props =>
        props.isValid &&
        props.isFilled &&
        `
        border: 1px solid rgb(164,168,33);
    `}

    ${props =>
        !props.isValid &&
        props.isFilled &&
        `
        background-color: rgba(227, 57, 128, 0.1);
        border: 1px solid rgb(227,57,128);
    `}
`;

const Label = styled.label`
    color: ${props => props.theme.secondary};
    font-family: vag-rounded-light, Helvetica, Arial, sans-serif;
    font-size: 1.4rem;
    left: 0.6rem;
    pointer-events: none;
    position: absolute;
    top: calc(50% + 1px);
    transition: 0.3s ease all;

    @media (prefers-reduced-motion) {
        transition: none;
    }

    ${Input}:focus ~ & {
        font-size: 1rem;
        left: 0;
        top: 0;
    }

    ${props =>
        props.isFilled &&
        `
        font-size: 1rem;
        left: 0;
        top: 0;
    `}
`;

export const SupplementaryText = styled.p`
    font-size: 1.2rem;
    margin: 1rem 0;
`;

export const ValidationMessage = styled.span`
    color: rgb(227, 57, 128);
    display: none;
    font-size: 1.2rem;

    ${props =>
        !props.isValid &&
        props.isFilled &&
        `
        display: block;
    `}
`;

InputFloating.propTypes = {
    description: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    max: PropTypes.string,
    min: PropTypes.string,
    pattern: PropTypes.string,
    required: PropTypes.bool,
    step: PropTypes.string,
    type: PropTypes.string,
    validationMessage: PropTypes.string
};
